import { deserialize } from '@compeon/jsonapi-serializer';

export default (context, inject) => {
  const d = payload => {
    if (!payload) {
      return null;
    }
    if (payload.raw) {
      return payload.raw;
    }
    if (payload.meta) {
      if (payload.meta.payload.pagination) {
        context.store.commit('utils/setPagination', payload.meta.payload.pagination);
        delete payload.meta.payload.pagination;
      }
      if (payload.meta.setter) {
        context.store.commit(payload.meta.setter, payload.meta.payload);
      }
    }
    return deserialize()(payload);
  };
  inject('deserialize', d);
  context.$deserialize = d;
};
